import { Badge } from '@chakra-ui/react'
import { ReactElement } from 'react'

import { StatusAprovacao, StatusDisparo } from '@service/followUpFornecedor'

// ─── statusAprovacaoBadge — used in Aprovacao view (green.600 / red.500 / orange.400) ─────
export const statusAprovacaoBadge = (v: number): ReactElement => {
  if (v === StatusAprovacao.Aprovado) {
    return (
      <Badge bg="green.600" color="white" borderRadius="md" px={2}>
        Aprovado
      </Badge>
    )
  }
  if (v === StatusAprovacao.Recusado) {
    return (
      <Badge bg="red.500" color="white" borderRadius="md" px={2}>
        Recusado
      </Badge>
    )
  }
  return (
    <Badge bg="orange.400" color="white" borderRadius="md" px={2}>
      Aguardando
    </Badge>
  )
}

const badgeStyle = (bg: string) => ({
  bg,
  color: 'white',
  borderRadius: 'md',
  px: 2,
  fontSize: '11px',
  fontWeight: '700',
  letterSpacing: '0.4px'
})

// ─── aprovacaoBadge — used in Listagem view (hex colours, smaller font) ────────
export const aprovacaoBadge = (v: number): ReactElement => {
  if (v === StatusAprovacao.Aprovado) {
    return <Badge {...badgeStyle('#16a34a')}>Aprovado</Badge>
  }
  if (v === StatusAprovacao.Recusado) {
    return <Badge {...badgeStyle('#dc2626')}>Recusado</Badge>
  }
  return <Badge {...badgeStyle('#d97706')}>Aguardando</Badge>
}

// ─── disparoBadge — used in Listagem view ──────────────────────────────────────
export const disparoBadge = (v: number): ReactElement => {
  const map: Record<number, { label: string; bg: string }> = {
    [StatusDisparo.AguardandoEnvio]: {
      label: 'Aguardando Envio',
      bg: '#b45309'
    },
    [StatusDisparo.EmailEnviado]: { label: 'E-mail Enviado', bg: '#1d6bbf' },
    [StatusDisparo.Submetido]: { label: 'Submetido', bg: '#6d28d9' },
    [StatusDisparo.Invalido]: { label: 'Inválido', bg: '#dc2626' },
    [StatusDisparo.Expirado]: { label: 'Expirado', bg: '#4b5563' },
    [StatusDisparo.ErroEnvio]: { label: 'Erro no Envio', bg: '#dc2626' }
  }
  const item = map[v] ?? { label: `${v}`, bg: '#4b5563' }
  return <Badge {...badgeStyle(item.bg)}>{item.label}</Badge>
}

// ─── situacaoBadge — used in Listagem view (replaces aprovacaoBadge for situacao field) ──
export const situacaoBadge = (
  v:
    | 'AguardandoFornecedor'
    | 'AguardandoAprovacao'
    | 'Aprovado'
    | 'Recusado'
    | 'ErroEnvio'
): ReactElement => {
  const map: Record<string, { label: string; bg: string }> = {
    AguardandoFornecedor: { label: 'Aguardando Fornecedor', bg: '#b45309' },
    AguardandoAprovacao: { label: 'Aguardando Aprovação', bg: '#1d6bbf' },
    Aprovado: { label: 'Aprovado', bg: '#16a34a' },
    Recusado: { label: 'Recusado', bg: '#dc2626' },
    ErroEnvio: { label: 'Erro no Envio', bg: '#dc2626' }
  }
  const item = map[v] ?? { label: v, bg: '#4b5563' }
  return <Badge {...badgeStyle(item.bg)}>{item.label}</Badge>
}

// ─── estadoRespostaBadge — used in Aprovacao view ──────────────────────────────
export const estadoRespostaBadge = (v: string): ReactElement => {
  if (v === 'ComAlteracoes') {
    return (
      <Badge bg="blue.500" color="white" borderRadius="md" px={2}>
        Com Alterações
      </Badge>
    )
  }
  return (
    <Badge bg="gray.500" color="white" borderRadius="md" px={2}>
      Sem Alterações
    </Badge>
  )
}
